document.documentElement.classList.add('js');

(function () {
  const quiz = document.querySelector('[data-pm-quiz]');
  if (!quiz) return;

  const data = {
    selvaggio: {
      title: 'Selvaggio',
      copy: 'Fresh, woody and fearless — built for confidence, movement and everyday presence.',
      link: '/products/selvaggio',
      image: window.Shopify ? '' : ''
    },
    credo: {
      title: 'Credo',
      copy: 'Clean, composed and quietly powerful — refined amber aromatic confidence.',
      link: '/products/credo'
    },
    roma: {
      title: 'Roma',
      copy: 'Warm, magnetic and made for after dark — floral woods with vanilla depth.',
      link: '/products/roma'
    },
    milioni: {
      title: 'Millioni',
      copy: 'Rich, ambitious and luxurious — chypre warmth with leather and spice.',
      link: '/products/millioni'
    },
    'la-costa': {
      title: 'La Costa',
      copy: 'Fresh, clean and coastal — citrus brightness with sandalwood and amber.',
      link: '/products/la-costa'
    },
    adorere: {
      title: 'Adorere',
      copy: 'Smooth, elegant and refined — floral brightness with vanilla, musk and woods.',
      link: '/products/adorere'
    }
  };

  const imageMap = {
    selvaggio: "pm-current-selvaggio.png",
    credo: "pm-current-credo.png",
    roma: "pm-current-roma.png",
    milioni: "pm-current-millioni.png",
    'la-costa': "pm-current-la-costa.png",
    adorere: "pm-current-adorere.png"
  };

  const steps = Array.from(quiz.querySelectorAll('.pm-quiz-step'));
  const result = quiz.querySelector('[data-quiz-result]');
  const title = quiz.querySelector('[data-result-title]');
  const copy = quiz.querySelector('[data-result-copy]');
  const link = quiz.querySelector('[data-result-link]');
  const img = quiz.querySelector('[data-result-image]');
  const reset = quiz.querySelector('[data-quiz-reset]');
  let score = {};
  let current = 0;

  quiz.querySelectorAll('[data-scent]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const scent = btn.getAttribute('data-scent');
      score[scent] = (score[scent] || 0) + 1;
      steps[current].classList.remove('is-active');
      current += 1;
      if (current < steps.length) {
        steps[current].classList.add('is-active');
      } else {
        const winner = Object.keys(score).sort((a, b) => score[b] - score[a])[0] || 'selvaggio';
        const selected = data[winner];
        title.textContent = selected.title;
        copy.textContent = selected.copy;
        link.href = selected.link;
        // Asset URLs are resolved by Shopify in a data attribute when available
        const assetNode = document.querySelector('[data-product-handle="' + winner + '"] img');
        if (assetNode) img.src = assetNode.src;
        img.alt = selected.title + ' Profumo Molfetta bottle';
        result.hidden = false;
      }
    });
  });

  if (reset) {
    reset.addEventListener('click', () => {
      score = {};
      current = 0;
      result.hidden = true;
      steps.forEach((step, idx) => step.classList.toggle('is-active', idx === 0));
    });
  }
})();

(function () {
  const revealItems = document.querySelectorAll('.pm-fragrance-card, .pm-lab-grid article, .pm-tech-card, .pm-policy-card');
  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  revealItems.forEach((item) => observer.observe(item));
})();
